import React from 'react';

type RetryOptions = {
  retries?: number;
  delay?: number;
  backoff?: boolean;
};

export const retry = async <T>(
  fn: () => Promise<T>,
  { retries = 5, delay = 1000, backoff = true }: RetryOptions = {},
): Promise<T> => {
  try {
    return await fn();
  } catch (error: any) {
    if (retries === 0) {
      throw error;
    }

    const nextDelay = backoff ? delay * 2 : delay;
    // console.log(`Retrying... ${retries} attempts remaining. Next retry in ${delay}ms`);
    await new Promise(resolve => setTimeout(resolve, delay));

    // If it's a module import error, try to add a cache-busting parameter
    if (
      error.message?.includes('Failed to fetch dynamically imported module:')
    ) {
      const url = new URL(
        error.message
          .replace('Failed to fetch dynamically imported module: ', '')
          .trim(),
      );
      url.searchParams.set('t', `${+new Date()}`);
      try {
        return await import(url.href);
      } catch (e) {
        console.log('retrying import with cache busting');
      }
    }

    return retry(fn, { retries: retries - 1, delay: nextDelay, backoff });
  }
};

export const lazyWithRetries: typeof React.lazy = importer => {
  // return React.lazy(() => retry(importer, { backoff: true }));
  return React.lazy(importer);
};
